import { createRouter } from '@tanstack/react-router';
import { routeTree } from '@/routes';
import { appQueryClient } from '../tanstack-query/root-provider';

export const router = createRouter({
  routeTree,
  context: {
    queryClient: appQueryClient,
  },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});
